module.exports = __webpack_public_path__ + "img/fullscreen.c2c1b2d5.svg";